import app from 'flarum/forum/app';
import { lineColor, photoFile, photoUrl } from '../cameraData';
import CameraPhotoModal from './CameraPhotoModal';

/**
 * One camera card, used in three places: the index grid, the detail hero and
 * the hover popover. The popover variant renders every element as a <span> --
 * inside a post body <p> anything else (div/ul/li) unwinds the paragraph and
 * kills the popover (hard-won lesson, see CAMERA_INDEX_PLAN.md §06).
 */
export function cameraCard(camera, { tag = 'div', detail = false, count = null } = {}) {
  const T = tag;
  const photo =
    detail && photoFile(camera) ? (
      <button
        type="button"
        className="CameraCard-photoBtn"
        aria-label={app.translator.trans('acseven-chdk-cameras.forum.card.view_photo', { name: camera.name })}
        onclick={() => app.modal.show(CameraPhotoModal, { camera })}
      >
        <img className="CameraCard-photoImg" src={photoUrl(camera)} alt={camera.name} />
      </button>
    ) : photoFile(camera) ? (
      <T className="CameraCard-photo">
        <img className="CameraCard-photoImg" src={photoUrl(camera)} alt={camera.name} loading="lazy" />
      </T>
    ) : (
      <T className="CameraCard-photo CameraCard-photo--fallback" style={{ background: lineColor(camera.line) }}>
        <span className="CameraCard-photo-letter">{camera.line}</span>
      </T>
    );

  return (
    <T className={'CameraCard' + (detail ? ' CameraCard--detail' : '')}>
      {photo}
      <T className="CameraCard-body">
        <T className="CameraCard-name">
          {camera.name}
          <span className="CameraCard-line" style={{ background: lineColor(camera.line) }}>
            {camera.line}
          </span>
        </T>
        {detail && (
          <T className="CameraCard-platformId">
            {'platform id: ' + camera.id}
            {camera.pid ? ' · PID 0x' + camera.pid.toString(16).toUpperCase() : ''}
            {camera.mid ? ' · MID 0x' + camera.mid.toString(16).toUpperCase() : ''}
          </T>
        )}
        {camera.aka.length > 0 && (
          <T className="CameraCard-aka">{camera.aka.slice(0, detail ? camera.aka.length : 2).join(' · ')}</T>
        )}
        <T className="CameraCard-meta">
          {camera.state === 'alpha' && (
            <span className="CameraCard-badge CameraCard-badge--alpha">
              {app.translator.trans('acseven-chdk-cameras.forum.badge.new_port')}
            </span>
          )}
          <span className="CameraCard-count">
            {/* The detail page passes its own count: it knows the 1.7
                autobuild too, so a camera with no stable build reads "1
                firmware version" there instead of "0". */}
            {app.translator.trans('acseven-chdk-cameras.forum.card.firmware_versions', {
              count: count === null ? camera.firmware.length : count,
            })}
          </span>
        </T>
      </T>
    </T>
  );
}
